module.exports = __webpack_public_path__ + "static/media/icn_info.dfa00689.svg";